import styled from 'styled-components'

export default styled.button`
    background: none;
    border: none;

    color: var(--green);
    font: var(--400-13);

    cursor: pointer;
  }
`
